/** The `mail` area: the mails the app sends (src/domain/mail.ts), formatted in
 *  the recipient's locale. A code, a link and an address are arguments. */
export const mail = {
  'mail.ignore': "If you didn't request this, you can ignore this email.",
  'mail.underAccount': 'Enter it under Account: {url}',
  'mail.orOpen': 'Or open: {url}',
  'mail.changeEmail.subject': 'Confirm your new Tesserano address',
  'mail.changeEmail.code':
    'Someone asked to move a Tesserano account to this address. Confirm it with this code: {code}',
  'mail.signIn.subject': 'Your Tesserano sign-in code',
  'mail.signIn.codeOnly': 'Your Tesserano sign-in code: {code}',
  'mail.signIn.typeIt': 'Type it on the sign-in page you have open.',
  'mail.signIn.code': 'Sign in to Tesserano with this code: {code}',
  'mail.reset.subject': 'Reset your Tesserano password',
  'mail.reset.code': 'Reset your Tesserano password with this code: {code}',
  'mail.verify.subject': 'Verify your Tesserano email',
  'mail.verify.code': 'Verify your Tesserano email with this code: {code}',
  'mail.approve.subject': 'Approve moving your Tesserano account',
  'mail.approve.code':
    'Someone asked to move this Tesserano account to {email}. Approve it with this code: {code}',
  'mail.approve.ignore': "If you didn't request this, ignore this email and change your password.",
  'mail.invite.subject': 'You have been invited on Tesserano',
  'mail.invite.intro': 'You have been invited to collaborate on Tesserano.',
  'mail.invite.open': 'Open your invite: {url}',
  'mail.invite.accept':
    'Sign in or create a free account with this email address to accept. This link expires in 14 days.',
} as const;
